import AWS from 'aws-sdk/browser';

import { Request, sign } from './v4Signature';

const AWSConfig = AWS.config;

export function signedImageSrc(method: 'GET' | 'POST', path: string): string {
  const host = import.meta.env.VITE_API_GATEWAY_HOST;
  const options = {
    method,
    host,
    path,
    region: import.meta.env.VITE_AWS_REGION,
    service: import.meta.env.VITE_AWS_SERVICE,
    signQuery: true,
  };

  const returned = sign(options, AWSConfig.credentials);

  return `https://${returned.host}${returned.path}`;
}

export function signedS3Download(bucket: string, key: string): string {
  const request: Request = {
    method: 'GET',
    region: import.meta.env.VITE_AWS_REGION,
    service: 's3',
    host: `s3-${import.meta.env.VITE_AWS_REGION}.amazonaws.com`,
    path: `/${bucket}/${key}`,
    signQuery: true,
    query: {
      'X-Amz-Expires': 3600,
    },
  };

  const returned = sign(request, AWSConfig.credentials);
  return `https://${returned.host}${returned.path}`;
}
